import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

import DocumentAttachment from '../../../components/ui/DocumentAttachment';
import { getDocuments, saveDocuments } from '../../../utils/documentManager';

const DocumentLibrary = ({ owner }) => {
  const [ownerDocuments, setOwnerDocuments] = React.useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [documentNotes, setDocumentNotes] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  React.useEffect(() => {
    if (owner?.id) {
      const docs = getDocuments('owner', owner?.id?.toString());
      setOwnerDocuments(docs);
    }
  }, [owner?.id]);

  const handleDocumentsChange = (docs) => {
    setOwnerDocuments(docs);
    if (owner?.id) {
      saveDocuments('owner', owner?.id?.toString(), docs);
    }
  };

  const handleSaveFilters = () => {
    setIsSaving(true);
    const filterSettings = {
      searchQuery,
      selectedCategory,
      documentNotes
    };
    localStorage.setItem(`documentFilters_${owner?.id}`, JSON.stringify(filterSettings));
    setTimeout(() => {
      setIsSaving(false);
      alert('تم حفظ إعدادات المستندات بنجاح');
    }, 500);
  };

  if (!owner) {
    return (
      <div className="bg-black rounded-lg border border-primary/30 p-6 text-center">
        <Icon name="FolderX" size={40} color="var(--color-muted-foreground)" />
        <p className="text-muted-foreground mt-3 text-sm">
          اختر مالكاً لعرض المستندات
        </p>
      </div>
    );
  }

  return (
    <div className="bg-black rounded-lg border border-primary/30 overflow-hidden">
      <div className="p-4 border-b border-primary/30">
        <div className="flex items-center justify-center gap-2 mb-4 px-4 py-3 rounded-xl border-2 shadow-warm-sm" style={{
          background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(251, 191, 36, 0.15) 100%)',
          borderColor: 'rgba(245, 158, 11, 0.4)'
        }}>
          <Icon name="FolderOpen" size={20} color="#F59E0B" />
          <h3 className="font-heading font-bold text-sm md:text-base" style={{
            background: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            مكتبة المستندات
          </h3>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-xs text-muted-foreground">
            {ownerDocuments?.length} مستند
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={handleSaveFilters}
            disabled={isSaving}
            iconName="Save"
            iconSize={16}
          >
            {isSaving ? 'حفظ...' : 'حفظ'}
          </Button>
        </div>
      </div>
      <div className="p-4">
        <DocumentAttachment
          documents={ownerDocuments}
          onChange={handleDocumentsChange}
          entityType="owner"
          entityId={owner?.id?.toString()}
        />
      </div>
    </div>
  );
};

export default DocumentLibrary;